import { Link } from 'react-router-dom';

/**
 * Logo-only header for standalone landing pages (no site navigation, so the
 * page's own form is the only call to action). The logo links back to the
 * product the landing page belongs to.
 */
export function MinimalHeader({ homeTo = '/', tag }: { homeTo?: string; tag?: string }) {
  return (
    <header className="border-b border-white/10 bg-[#141A45]">
      <div className="container mx-auto flex h-16 items-center justify-between gap-6 px-4">
        <Link to={homeTo} className="flex shrink-0 items-center">
          <img
            src="/assets/logos/white-logo---no-background.svg"
            alt="CriticalBridge.AI"
            className="h-9"
          />
        </Link>
        {tag && (
          <span className="hidden font-mono text-xs uppercase tracking-widest text-white/60 sm:block">
            {tag}
          </span>
        )}
      </div>
    </header>
  );
}
